import { render } from "./arrangement-radio.vue?vue&type=template&id=ee02cb86&scoped=true"
import script from "./arrangement-radio.vue?vue&type=script&lang=js"
export * from "./arrangement-radio.vue?vue&type=script&lang=js"

import "./arrangement-radio.vue?vue&type=style&index=0&id=ee02cb86&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee02cb86"]])

export default __exports__